import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { NewsListComponent } from './list/news-list.component';
import { NewsCreateComponent } from './create/news-create.component';
import { NewsUpdateComponent } from './update/news-update.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: NewsListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'news.read'
            }
          }
        ]
      },
      {
        path: 'create',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Add News'
        },
        children: [
          {
            path: '',
            component: NewsCreateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'news.create'
            }
          }
        ]
      },
      {
        path: ':id/update',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Update News'
        },
        children: [
          {
            path: '',
            component: NewsUpdateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'news.update'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewsRoutingModule {}
